import { ValidationErrors, ValidatorFn, AbstractControl } from "@angular/forms";
import { RFC } from "./rfc";

export const rfcDigitCongruence: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (control.value == "") {
    return null;
  }
  const rfc = control.value.toUpperCase();
  let result = RFC.digitValidator(rfc);
  return result ? null : { invalidRfc: true };
};
